import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { switchBySiteId } from '../../utils'

const getDefaultImage = () => {
  const { host, protocol } = window.location
  const file = switchBySiteId(
    {
      1: 'fw_pharma_large_logo.png',
      2: 'fw_healthtech_large_logo.png',
      3: 'fw_reports_large_logo.png'
    },
    null
  )
  if (!file) return null
  return `${protocol}//${host}/assets/${file}`
}

const Metadata = ({
  title,
  description,
  image,
  publicationDate,
  type = 'website',
  author
}) => {
  const resolvedImage = image ?? getDefaultImage()

  const safeLocation = window.location.href
  return (
    <Helmet>
      {/* Native */}
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      {/* Facebook / Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={safeLocation} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {author && <meta property="og:author" content={author} />}
      {resolvedImage && <meta property="og:image" content={resolvedImage} />}
      {resolvedImage && <meta property="og:image:width" content="300" />}
      {resolvedImage && <meta property="og:image:height" content="300" />}

      {/* Publication date for Open Graph */}
      {publicationDate && (
        <meta
          property="article:published_time"
          content={new Date(publicationDate * 1000).toISOString()}
        />
      )}

      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:url" content={safeLocation} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {resolvedImage && <meta name="twitter:image" content={resolvedImage} />}
    </Helmet>
  )
}

Metadata.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  publicationDate: PropTypes.string,
  type: PropTypes.string,
  author: PropTypes.string
}

export default Metadata
